import React, { useContext } from 'react';
import 'react-dates/lib/css/_datepicker.css';
import { Button, Input, Select } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { RegistrationForm } from 'src/assets/styles/components/Registration';
import { sortArray, errorInput, searchSelectProps } from 'src/components/helpers';
import useRememberCredentials from 'src/components/helpers/useRememberCredentials';
import RememberCredentialsCheckbox from 'src/components/helpers/RememberCredentialsCheckbox';
import { ListsContext } from 'src/services/contextProviders/lists/listsContext';

const VolunteerLog = (props) => {
  const { inputs, setInputs, getInfo, parsedQueryString, loading, handleInputs } = props;
  const [errorInputs, set_errorInputs] = React.useState({});
  const { churchMinistries } = useContext(ListsContext);
  const { rememberCredentials, setRememberCredentials, persistCredentials } =
    useRememberCredentials({ setInputs });

  const verifyForm = () => {
    let mandatoryInputs = ['identification', 'phone', 'serviceArea'];
    let errorInputs = {};

    mandatoryInputs.forEach((input) => {
      errorInputs = errorInput({
        errorInputs,
        input: { name: input, value: inputs[input] },
      });
    });

    if (inputs['identification'] && inputs['identification'].length <= 5) {
      errorInputs = errorInput({
        errorInputs,
        input: {
          name: 'identification',
          value: inputs['identification'].length >= 5,
        },
      });
    }

    set_errorInputs(errorInputs);
    return Object.values(errorInputs).includes(true);
  };

  React.useEffect(() => {
    if (
      parsedQueryString?.identification &&
      parsedQueryString?.phone &&
      inputs.identification &&
      inputs.phone
    )
      enterReservation({ preventDefault: () => {} });
  }, [inputs.identification]);

  const enterReservation = (e) => {
    e.preventDefault();
    if (verifyForm()) return;
    persistCredentials({
      identification: inputs.identification,
      phone: inputs.phone,
    });
    getInfo();
  };

  const selectHandle = (a, { value, name }) => handleInputs({ target: { value, name } });

  return (
    <>
      <h2 style={{ textAlign: 'center' }}>¡Bienvenido!</h2>
      <RegistrationForm onSubmit={(e) => enterReservation(e)}>
        <label style={{ display: 'block', padding: '20px', fontSize: '35px' }}>
          Escribe tus datos
        </label>
        {Object.values(errorInputs).includes(true) && (
          <h4 style={{ color: 'red' }}>Por favor verifica los campos en rojo.</h4>
        )}
        <Input
          style={{ width: '45%' }}
          onChange={handleInputs}
          name={'identification'}
          value={inputs.identification}
          type="number"
          placeholder="Identificación"
          id="identification"
          className={`Registration__input Registration__input-${'identification'} ${
            errorInputs['identification'] ? 'error' : ''
          }`}
        />
        <Input
          placeholder="Celular"
          id="phone"
          name={'phone'}
          type="number"
          className={`Registration__input Registration__input-${'phone'} ${
            errorInputs['phone'] ? 'error' : ''
          }`}
          value={inputs.phone}
          onChange={handleInputs}
          style={{ width: '45%', margin: '5px' }}
        />
        <RememberCredentialsCheckbox
          checked={rememberCredentials}
          onChange={setRememberCredentials}
        />
        <div>
          <Select
            placeholder={'Area de Servicio'}
            className={errorInputs?.serviceArea ? 'error' : ''}
            style={{ margin: '0 0 20px 0' }}
            {...searchSelectProps({
              name: 'serviceArea',
              value: inputs?.serviceArea,
              handler: selectHandle,
              options: sortArray(churchMinistries).map((opt) => ({
                key: opt?.key,
                value: opt?.key,
                text: opt?.name,
              })),
            })}
          />
        </div>
        <Button primary disabled={loading} type="submit">
          Entrar
        </Button>
      </RegistrationForm>
    </>
  );
};

export default withRouter(VolunteerLog);
